<div
  id="streetview-container"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div id="streetview-pano" #streetviewPano></div>
</div>
